import { useCallback, useState } from "react";
import * as XLSX from "xlsx";

const useExcelDownloader = () => {
  const [csvStatus, setCsvStatus] = useState(false);

  const downloadExcel = useCallback(
    (data, headers, fileName = "FormatReport.xlsx") => {
      if (!headers || headers.length === 0) {
        console.warn("No headers provided for download");
        return;
      }

      setCsvStatus(true); // Start loading

      try {
        // Create an array of objects with correct keys for the sheet
        const formattedData = data.map((item) => {
          const row = {};
          headers.forEach(({ key, label }) => {
            row[label] = item[key] ?? "";
          });
          return row;
        });

        // Create worksheet and workbook
        const worksheet = XLSX.utils.json_to_sheet(formattedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Write the file
        XLSX.writeFile(workbook, fileName);
      } catch (error) {
        console.error("Excel Download Failed:", error);
      } finally {
        setCsvStatus(false);
      }
    },
    []
  );

  return { downloadExcel, csvStatus };
};

export default useExcelDownloader;
